import { useEffect, useState, useRef } from "react";
import momentumlogo from "../assets/images/Momentum Logo (2).png";
import Loader from "../Common/Loader";
import AccessDenied from "../assets/images/not-allowed-symbol.svg";
import CommonValues from "../Common/utils";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Toast } from "primereact/toast";

export default function BridgeValidationPage() {
  const [loading, setLoading] = useState(true);
  const toast: any = useRef("");
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(window.location.search);
  const token = searchParams.get("token");

  useEffect(() => {
    CommonValues.ClearAllValues();
    validateNowcertsToken(token);
  }, []);
  const validateNowcertsToken = (token: any) => {
    setLoading(true);
    var config = {
      method: "get",
      url: `${process.env.REACT_APP_AUTHAPI}/api/account/validateAlexandriaToken?token=${token}`,
    };

    axios(config)
      .then((response: any) => {
        if (response.data.token === "") {
          CommonValues.Logout(navigate);
        } else {
          localStorage.setItem("SocialLogin", "true");
          localStorage.setItem("igtoken", response.data.token);
          localStorage.setItem("userName", response.data.userName);
          localStorage.setItem("RoleId", response.data.roleId);
          localStorage.setItem("NowcertsAgentId", response.data.nowCertsAgentId);
          localStorage.setItem("AvatarName", response.data.avatarName);

          getNcToken(response.data.userName);
        }
      })
      .catch((error: any) => {
        setLoading(false);
        if (error.response !== null) {
          if (error.response.status === 401) {
            CommonValues.Logout(navigate);
          }
        } else {
          toast.current.show({ severity: "error", summary: "Error", detail: "Unknown error while getting details!", life: 3000 });
        }
      });
  };
  const getNcToken = (ncSetupUserName: any) => {
    let token = CommonValues.GetToken();
    var data = JSON.stringify({
      NCUserName: ncSetupUserName,
    });
    var config = {
      method: "post",
      url: `${process.env.REACT_APP_UserService_Url}/api/user/verifyMomentumCreds`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then((response: any) => {
        if (response.data != "" && response.data != null) {
          localStorage.setItem("NCToken", response.data.access_token);
          localStorage.setItem("NCAgencyId", response.data.agencyId);
          navigate("/chat");
        }
      })
      .catch((error: any) => {
        console.log(error);
        setLoading(false);
        if (error.response !== null) {
          if (error.response.status === 401) {
            navigate("/");
            CommonValues.Logout(navigate);
          } else if (error.response.status === 409) {
            toast.current.show({
              severity: "info",
              summary: "Info",
              detail: "It look likes you are not registered with NowCerts, Please register first.",
              life: 3000,
            });
          } else {
            toast.current.show({ severity: "error", summary: "Error", detail: "Unknown error while updating the NowCerts Settings", life: 3000 });
          }
        } else {
          toast.current.show({ severity: "error", summary: "Error", detail: "Unknown error while updating the NowCerts Settings", life: 3000 });
        }
      });
  };
  return (
    <>
      <Toast ref={toast} />

      <div className="d-flex vh-100 bg-light d-flex justify-content-center align-items-center">
        <div className="flex-grow-1  ">
          <div className="container-xl ">
            <div className="row g-3 d-flex justify-content-center align-items-center ">
              <div className="col-4">
                <div className="card shadow-sm border-0 show-cursor p-3">
                  {loading ? (
                    <div className="card-body text-center">
                      <img src={momentumlogo} alt="Logo" height={48} />
                      <h3>Launching</h3>
                      <div className="d-flex justify-content-center">
                        <Loader />
                      </div>
                    </div>
                  ) : (
                    <div className="card-body text-center">
                      <img src={AccessDenied} height={35} width={35} alt="Logo" />
                      <p className="not-authorize-text">
                        <b>You are not authorized</b>
                      </p>
                      <p className="d-block">
                        It seems like you don't have permission to use this portal.
                        <br /> Please sign in with a different account.{" "}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
